import { useQuery } from '@tanstack/react-query'
import { tenantsApi } from '../api'

export function useTenantUsage(tenantId: string | undefined) {
  return useQuery({
    queryKey: ['tenant-usage', tenantId],
    queryFn: async () => {
      if (!tenantId) throw new Error('Tenant ID is required')
      const response = await tenantsApi.getUsage(tenantId)
      return response.data.data
    },
    enabled: !!tenantId,
  })
}
